@if (searchState$ | async; as searchState) {
  @if (!hideSearchResultList) {
    <campus-results-list
      class="search-results"
      [resultsPage]="searchResults"
      [searchMode]="searchMode"
      [searchState]="searchState"
      (sortBy)="onSort($event)"
      (getNextPage)="onScroll()"
      [listFormat]="listFormat"
    ></campus-results-list>
  }
}
